import React, {useState} from "react";

export default function Client(props) {
    const [ openState, setOpenState ] = useState({
        isOpen: false
    });
    function showQuote() {
        setOpenState( state => ({
            isOpen: !state.isOpen
        }))
    };
    return (
        <div className={openState.isOpen ? "expand client-container clearfix" : "client-container clearfix"} id={props.id}>
            <img src={props.img} loading="lazy" alt={props.name + " - " + props.competition} className="client-image" id={`${props.id}-img`} />
            <div className="client" id={`${props.id}-div`}>
                <h3>{props.name}</h3>
                {props.competition.map(i => <h4>{i}</h4>)}
                <button className="transition client-button" onClick={()=> showQuote()}>See what she says about Team Eskew</button>
            <q className="testimonial">{props.testimonial}</q>
            </div>
        </div>
        // <div className={openState.isOpen ? "staffMember clearfix expand" : "staffMember clearfix"}>
        //     <img src={props.img} alt={props.name + " - " + props.competition} className="staffImg transition" loading="lazy"/>
        //     <div className="staffBio transition"> 
        //         <button className="staffClose transition" onClick={()=> showQuote()}>+</button>
        //         <div onClick={()=> showQuote()}>
        //             <h3>{props.name}</h3>
        //             {props.competition.map(i => <h4>{i}</h4>)}
        //         </div>
        //         <p>{props.testimonial}</p>
        //     </div>
        // </div>
    )
}